/* Recipes flip cards. Added by Oleg @ IAKOE.
   The carousel is the kit's <ia-slider>; this only toggles the card flip.
   Intentional exception to "custom JS = web component": one delegated listener
   covers every card on the page (lighter than a per-card component for a
   simple flip, and survives innerHTML swaps). Agreed with Oleg. */

if (!window.__tsRecipesFlipBound) {
  window.__tsRecipesFlipBound = true;

  const flip = (target) => {
    // The recipe link (.ia-button) navigates instead of flipping the card.
    if (target.closest('.ia-button')) return false;
    const trigger = target.closest('[data-ts-flip]');
    if (!trigger) return false;
    const card = trigger.closest('.ts-recipe-card');
    if (card) card.classList.toggle('is-flipped');
    return true;
  };

  document.addEventListener('click', (event) => {
    flip(event.target);
  });

  // Keyboard support for the front face (role="button")
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.matches('[data-ts-flip]')) return;
    if (flip(event.target)) event.preventDefault();
  });
}
